export default __webpack_public_path__ + "static/media/lounge.9665ad03.jpg";